import Header from '../../Components/Header/Header';
import React, { useEffect, useState } from 'react';
import './CancelAssignment.css';
import { putCall } from '../../Services/CommonService';
import { useNavigate, useParams } from 'react-router-dom';
import AssignmentDetailsHeader from '../common/AssignmentDetailsHeader';
import { getUserInfoFromSession } from '../../Services/session.mgmt';
import * as Constants from '../../constants/RepoReactConstants';

import { CommonDataService } from '../../Services/CommonDataService';
import { FcnaDB2Postcall } from '../../api/accountsummary.api';
import { AssignmentService } from '../../Services/AssignmentService';
import BuyerAssignmentInfo from '../../Components/BuyerAssignmentInfo';
import Button from '../../Components/Button/Button';
import { logPinnacleContact } from '../../Services/PinnacleService';

function CancelAssignment() {
  const navigate = useNavigate();
  let { teamWrkBpiNb } = useParams();
  console.log(teamWrkBpiNb);

  const [accountInformation, setAccountInformation] = useState([]);
  const [contractorInfoForComment, setContractorInfoForComment] = useState([]);

  const [assignmentDetails, setAssignmentDetails] = useState([]);
  const [buyerCoBuyerInfo, setBuyerCoBuyerInfo] = useState([]);
  const userInfo = getUserInfoFromSession();

  useEffect(() => {
    function callGetBuyerCobuyerInfo(accountInfoResponse) {
      console.log('In CancelAssignment callGetBuyerCobuyerInfo');
      AssignmentService.getBuyerCobuyerInfo(
        accountInfoResponse?.data?.coBusCd,
        accountInfoResponse?.data?.discorigBranchCd,
        accountInfoResponse?.data?.custAcctNb
      )
        .then((buyerInfoResp) => {
          console.log('getBuyerCobuyer response:', buyerInfoResp);
          setBuyerCoBuyerInfo(buyerInfoResp?.data);
        })
        .catch((error) => {
          console.error('AssignmentService.getBuyerCobuyerInfo error:: ', error);
        });
    }
    function callPromiseAll() {
      Promise.all([
        CommonDataService.getAccountInfo(teamWrkBpiNb, userInfo.cntrctrNb),
        CommonDataService.getCntrctrInfoForComments(userInfo.userid),
        AssignmentService.getAssignmentInfo(teamWrkBpiNb, userInfo.cntrctrNb),
      ])
        .then(([accountInfoResponse, contractorInfoForCommentResponse, assignmentResponse]) => {
          setAccountInformation(accountInfoResponse.data);
          setContractorInfoForComment(contractorInfoForCommentResponse.data);
          setAssignmentDetails(assignmentResponse.data);

          console.log(
            `getBuyerCobuyer Params coBusCd: ${accountInfoResponse?.data?.coBusCd} ` +
            `disorigBranchCd: ${accountInfoResponse?.data?.discorigBranchCd} ` +
            `custAcctNb: ${accountInfoResponse?.data?.custAcctNb}`
          );
          callGetBuyerCobuyerInfo(accountInfoResponse);
        })
        .catch((error) => {
          console.error('An error occurred:', error);
        });
    }
    const fetchcommonInfo = async () => {
      try {
        callPromiseAll();
      } catch (error) {
        // Handle any errors that occur in any of the promises
        console.error('An error occurred:', error);
      }
    };
    fetchcommonInfo();
  }, [teamWrkBpiNb, userInfo.cntrctrNb, userInfo.userid]);


  const onclickHandler = async () => {

    let callFcnaDb2 = true;
    const assignedContractorsResponse = await AssignmentService.getAssignedContractors(teamWrkBpiNb);
    for (const contractor of assignedContractorsResponse.data) {
      if(contractor === userInfo.cntrctrNb) continue;

      const assignmentStatusReponse = await AssignmentService.getRepoAssignmentStatusInfo(teamWrkBpiNb, contractor);
      if(assignmentStatusReponse.data.result.repoAssignmentStatus[0].cntrctrActnCd !== 'C') {
        callFcnaDb2 = false;
      }
    }

    Promise.all([
      logPinnacleContact(
        accountInformation,
        contractorInfoForComment,
        userInfo,
        Constants.ACTION_CANCEL,
        Constants.rsCANCEL_CONFIRM
      ),
      putCall(
        'processQuestion/updateCntrctAcct?bpiNb=' +
        teamWrkBpiNb +
        '&cntrctrNb=' +
        userInfo.cntrctrNb +
        '&sConfirm=Y&sCsrAction=C'
      ),
      callFcnaDb2 ? FcnaDB2Postcall({
        acctNb: accountInformation?.custAcctNb,
        coBusCd: accountInformation?.coBusCd,
        transTypeCd: 21,
        sourceSystemCode: 12,
        lastUpdatedUserIdentificationCode: 'FCREPO',
        transactionDataText: teamWrkBpiNb + ';CANCEL_CONFIRM',
        isImmediate: true,
      }) : Promise.resolve(null),
    ])
      .then(([pinnResp, putResp, fcnadb2Resp]) => {
        console.log('Pinnacle Response:', JSON.stringify(pinnResp));
        console.log('putCall Response:', JSON.stringify(putResp));
        if (fcnadb2Resp) {
          console.log('FcnaDB2Postcall Response:', JSON.stringify(fcnadb2Resp));
        }
      })
      .catch((error) => {
        console.error('Error in Promise.all:', error);
      })
      .finally(() => {
        navigate('/outstandingAssignment');
      });
  };

  return (
    <>
      <Header heading="Cancel Assignment" />
      <br />
      <AssignmentDetailsHeader bpiNo={teamWrkBpiNb} />
      <br />
      <div>
        <BuyerAssignmentInfo buyerCoBuyerInfo={buyerCoBuyerInfo} assignmentDetails={assignmentDetails} />
        <br />
        <section>
          <div className="center">
            <Button label="Acknowledge" onClick={onclickHandler} />
          </div>
        </section>
      </div>
    </>
  );
}

export default CancelAssignment;
